<template>
  <div class="date-select">
    <div class="date-filter">
      <i class="fa fa-calendar"></i>
      <multiselect label="name" id="datefilter" v-model="timeInterval" :options="allTimeIntervals" :searchable="false"
                   :close-on-select="true" :show-labels="false" placeholder="Zeitintervall wählen"
                   @select="handleAction" @remove="handeDeslect"></multiselect>
    </div>
    <template v-if="individualDate">
      <label for="start">von</label>
      <input @change="handleDateChange" type="date" id="start" name="filter-start"
             v-model="individualDateStart">
      <label for="end">bis</label>
      <input @change="handleDateChange" type="date" id="end" :max="today" name="filter-end"
             v-model="individualDateEnd">
    </template>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'DateFilter',
  props: [],
  components: {
    Multiselect
  },
  data() {
    return {
      timeInterval: [ {name: "heute", action: 'today'}],
      allTimeIntervals: [
        {name: "heute", action: 'today'},
        {name: "letzten 7 Tage", action: 'oneweek'},
        {name: "letzten 30 Tage", action: 'fourweeks'},
        {name: "letzten 365 Tage", action: 'year'},
        {name: "individueller Zeitraum", action: 'individual'},
      ],
      individualDate: false,
      individualDateStart: moment().format('YYYY-MM-DD'),
      individualDateEnd: moment().format('YYYY-MM-DD'),
    }
  },
  methods: {
    handleAction(selectedOption, id) {
      this.individualDate = false;
      switch (selectedOption.action) {
        case 'today':
          this.$parent.$emit('filter', {data: {low: 1, high: 0}, filter: 'date'});
          break;
        case 'oneweek':
          this.$parent.$emit('filter', {data: {low: 7, high: 0}, filter: 'date'});
          break;
        case 'fourweeks':
          this.$parent.$emit('filter', {data: {low: 30, high: 0}, filter: 'date'});
          break;
        case 'year':
          this.$parent.$emit('filter', {data: {low: 356, high: 0}, filter: 'date'});
          break;
        case 'individual':
          this.individualDate = true;
          break;
        default:
          break;
      }
    },
    handleDateChange(){
      const diffStartToday = moment().diff(this.individualDateStart, "days");
      const diffEndTody = moment().diff(this.individualDateEnd, "days");
      this.$parent.$emit('filter', {data: {low: diffStartToday, high: diffEndTody}, filter: 'date'});
    },
    handeDeslect(){
      this.$parent.$emit('filter', {data: {low: 1, high: 0}, filter: 'date'});
    }
  },
  computed: {
    today: function () {
      return moment().format('YYYY-MM-DD');
    },
  },
}
</script>
<style lang="scss" scoped>
.date-select {
  width: 100%;
  .date-filter {
    position: relative;
    i {
      position: absolute;
      top: 20px;
      right: 1em;
      transform: translateY(-50%);
      z-index: 9992;
    }
  }
}
</style>
